import {
  SECTION_CHILD_PATHS,
  SIDEBAR_SECTIONS,
  SidebarSectionItem,
} from '@/features/navigation/sidebar/sidebar.config';

function parseEnvList(v?: string): string[] {
  if (!v) return [];
  return v
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

const allowedList = parseEnvList(import.meta.env.VITE_SIDEBAR_SECTION_PATHS as string | undefined);
const allowed = new Set(allowedList);
const showAll = allowed.size === 0;

export function isPathAllowed(path?: string) {
  if (!path) return false;
  if (showAll) return true;

  if (allowed.has(path)) return true;

  for (const base of allowedList) {
    if (path.startsWith(base.endsWith('/') ? base : base + '/')) return true;
  }

  return false;
}

export const VISIBLE_SIDEBAR_SECTIONS: readonly SidebarSectionItem[] = SIDEBAR_SECTIONS.filter((section) => {
  if (isPathAllowed(section.to)) return true;
  return SECTION_CHILD_PATHS[section.to]?.some(isPathAllowed) ?? false;
});
